import React from "react";
import { Button } from "@mui/material";
import { useSelector } from "react-redux";
import socket from "../../utils/socket";
import { useAppDispatch } from "../../redux/store";
import { createEngagement } from "../../redux/actions/engagementActions"; 



interface PostbackButtonProps {
  title: string;
  payload: string;
  onPostback: (payload: string) => void;
  theme: string;
  isReplied: boolean;
  messageId?: string; // Add messageId prop
  disabled?: boolean;
}

const PostbackButton: React.FC<PostbackButtonProps> = ({
    title,
    payload,
    onPostback = () => {}, // Default empty function
    theme,
    isReplied,
    messageId = "",
    disabled = false // Add explicit disabled prop
}) => {
    const { user } = useSelector((state: any) => state);
    const dispatch = useAppDispatch();
    
   if (title.includes('null')) {
      return null;
   }

    // Combine isReplied and disabled props
    const isButtonDisabled = isReplied || disabled;

    const sendRichMessage = () => {
        // Don't proceed if button is disabled
        if (isButtonDisabled) return;
        
        const normalizedPayload = payload.replace(/(?:^<)|(?:>$)/g, "");

        onPostback(normalizedPayload);

        // After sending a message, only disable buttons for this specific message
        if (messageId) {
            const messageElement = document.querySelector(`[data-message-id="${messageId}"]`);
            if (messageElement) {
                const buttons = messageElement.getElementsByClassName('dafabet');
                Array.from(buttons).forEach(button => {
                    button.setAttribute('disabled', 'true');
                    if (button instanceof HTMLElement) {
                        button.style.backgroundColor = 'lightgray';
                        button.style.color = 'darkgray';
                        button.style.cursor = 'not-allowed';
                    }
                });
            }
        }

        const richMedia = {
            selectedAction: {
                type: "reply",
                payload: normalizedPayload,
            },
        };

        const body = {
            elementType: "reply",
            elementText: {
                text: title,
                textFormat: "PLAINTEXT",
            },
            payload: normalizedPayload,
            richMediaPayload: richMedia,
        };

        let providerDialogId;

        if (user.user.engagementParameters.CustomerVerified === "true") {
            providerDialogId =
                user.user.chProviderDialogId !== undefined
                    ? user.user.chProviderDialogId
                    : user.user.providerDialogId;
        } else {
            providerDialogId = user.user.providerDialogId;
        }

        let providerSenderId;

        if (user.user.engagementParameters.CustomerVerified === "true") {
            providerSenderId = user.user.chProviderSenderId !== undefined 
                ? user.user.chProviderSenderId 
                : user.user.providerSenderId;
        } else {
            providerSenderId = user.user.providerSenderId;
        }

        const message = {
            body,
            senderName: user?.user?.displayName || "default",
            providerDialogId,
            providerSenderId,
            engagementParam: user.user.engagementParameters,
            customerIdentifiers: user.user.customerIdentifiers,
        };

        const s = socket.getInstance();
        s.emit("message", message, (res: any) => {
            if (res.hasError) {
                console.error(res);
            }
        });
        dispatch(createEngagement({ payload: normalizedPayload }));
    };

    return (
        <Button
            variant="contained"
            className={theme}
            disabled={isButtonDisabled}
            onClick={sendRichMessage}
            sx={{
                borderRadius: "14px",
                padding: "0.3rem 2rem",
                margin: "0.5rem 0",
                backgroundColor: isButtonDisabled ? "lightgray" : "#af0000",
                color: isButtonDisabled ? "darkgray" : "#fff",
                textTransform: "capitalize",
                cursor: isButtonDisabled ? "not-allowed" : "pointer",
                "&:hover": {
                    backgroundColor: isButtonDisabled ? "lightgray" : "#ffe000",
                    color: isButtonDisabled ? "darkgray" : "#000",
                },
            }}
        >
            {title}
        </Button>
    );
};

export default PostbackButton;
